interface Env {
  production: boolean;
  apiUrl: string;
  enableDebug: boolean;
  environment: string;
  oauthClientId: string;
  comcastClientId: string;
  passportEndpoint: string;
}

type IconName = 'sky';

interface Icon {
  asset: string;
}

interface Region {
  name: string;
  icon?: Icon;
}

const environments: Record<string, Record<string, Env>> = {
  US: {
    dev: {
      production: true,
      apiUrl: 'https://xca-api-dev.xpki.io',
      enableDebug: false,
      environment: 'dev',
      oauthClientId: 'fa331720-01ec-4661-b9ce-4b2581252d56',
      comcastClientId: 'xpki-xca-dev',
      passportEndpoint: 'enterprise.xerxes.comcast.net',
    },

    qa: {
      production: true,
      apiUrl: 'https://xca-api-qa.xpki.io',
      enableDebug: false,
      environment: 'qa',
      oauthClientId: 'fa331720-01ec-4661-b9ce-4b2581252d56',
      comcastClientId: 'xpki-xca-qa',
      passportEndpoint: 'enterprise.xerxes.comcast.net',
    },

    stage: {
      production: true,
      apiUrl: 'https://xca-api-stage.xpki.io',
      enableDebug: false,
      environment: 'stage',
      oauthClientId: 'fa331720-01ec-4661-b9ce-4b2581252d56',
      comcastClientId: 'xpki-xca-stage',
      passportEndpoint: 'enterprise.xerxes.comcast.net',
    },

    prod: {
      production: true,
      apiUrl: 'https://xca-api.xpki.io',
      enableDebug: false,
      environment: 'stage',
      oauthClientId: 'fa331720-01ec-4661-b9ce-4b2581252d56',
      comcastClientId: 'xpki-xca-prod',
      passportEndpoint: 'enterprise.xerxes.comcast.net',
    },
  },

  // FIXME: apiUrl for UK
  UK: {
    dev: {
      production: true,
      apiUrl: 'https://xca-api-dev.xpki.io',
      enableDebug: false,
      environment: 'dev',
      oauthClientId: 'fa331720-01ec-4661-b9ce-4b2581252d56',
      comcastClientId: 'xpki-xca-eu-dev',
      passportEndpoint: 'ent.eu.stg.xerxes.comcast.com',
    },

    qa: {
      production: true,
      apiUrl: 'https://xca-api-qa.xpki.io',
      enableDebug: false,
      environment: 'qa',
      oauthClientId: 'fa331720-01ec-4661-b9ce-4b2581252d56',
      comcastClientId: 'xpki-xca-eu-qa',
      passportEndpoint: 'ent.eu.stg.xerxes.comcast.com',
    },

    stage: {
      production: true,
      apiUrl: 'https://xca-api-stage.xpki.io',
      enableDebug: false,
      environment: 'stage',
      oauthClientId: 'fa331720-01ec-4661-b9ce-4b2581252d56',
      comcastClientId: 'xpki-xca-eu-stage',
      passportEndpoint: 'ent.eu.stg.xerxes.comcast.com',
    },

    prod: {
      production: true,
      apiUrl: 'https://xca-api.xpki.io',
      enableDebug: false,
      environment: 'stage',
      oauthClientId: 'fa331720-01ec-4661-b9ce-4b2581252d56',
      comcastClientId: 'xpki-xca-eu-prod',
      passportEndpoint: 'ent.eu.stg.xerxes.comcast.com',
    },
  },

  east: {
    stage: {
      production: true,
      apiUrl: 'https://xca-api-stage-east.xpki.io',
      enableDebug: false,
      environment: 'stage',
      oauthClientId: 'fa331720-01ec-4661-b9ce-4b2581252d56',
      comcastClientId: 'xpki-xca-stage',
      passportEndpoint: 'enterprise.xerxes.comcast.net',
    },

    prod: {
      production: true,
      apiUrl: 'https://xca-api-east.xpki.io',
      enableDebug: false,
      environment: 'stage',
      oauthClientId: 'fa331720-01ec-4661-b9ce-4b2581252d56',
      comcastClientId: 'xpki-xca-prod',
      passportEndpoint: 'enterprise.xerxes.comcast.net',
    },
  },

  west: {
    stage: {
      production: true,
      apiUrl: 'https://xca-api-stage-west.xpki.io',
      enableDebug: false,
      environment: 'stage',
      oauthClientId: 'fa331720-01ec-4661-b9ce-4b2581252d56',
      comcastClientId: 'xpki-xca-stage',
      passportEndpoint: 'enterprise.xerxes.comcast.net',
    },

    prod: {
      production: true,
      apiUrl: 'https://xca-api-west.xpki.io',
      enableDebug: false,
      environment: 'stage',
      oauthClientId: 'fa331720-01ec-4661-b9ce-4b2581252d56',
      comcastClientId: 'xpki-xca-prod',
      passportEndpoint: 'enterprise.xerxes.comcast.net',
    },
  },
};

const icons: Record<IconName, Icon> = {
  sky: { asset: 'images/sky_logo.png' },
};

// Important:
// update this object when adding or removing regions
const regions: Record<string, Region> = {
  US: {
    name: 'US',
  },
  UK: {
    name: 'UK',
    icon: icons.sky,
  },
  east: {
    name: 'east',
  },
  west: {
    name: 'west',
  },
};

// Used to detect env by domain
const domains: Record<string, string[]> = {
  prod: ['xca.xpki.io', 'xca-east.xpki.io', 'xca-west.xpki.io'],
  stage: [
    'xca-stage.xpki.io',
    'xca-stage-east.xpki.io',
    'xca-stage-west.xpki.io',
  ],
  qa: ['xca-qa.xpki.io'],
  dev: ['xca-dev.xpki.io'],
};
const defaultEnv = 'dev';

// Used to detect region by domain
const regionDomains: Record<string, string[]> = {
  US: [],
  UK: [],
  east: ['xca-east.xpki.io', 'xca-stage-east.xpki.io'],
  west: ['xca-west.xpki.io', 'xca-stage-west.xpki.io'],
};
const defaultRegion = 'US';

function detectEnv(domain: string): Env {
  const regionName = detectRegion(domain).name;
  const regionEnvironments = environments[regionName];
  for (const [envName, env] of Object.entries(regionEnvironments)) {
    for (const [envName2, envDomains] of Object.entries(domains)) {
      if (envName === envName2 && envDomains.includes(domain)) {
        return env;
      }
    }
  }
  return regionEnvironments[defaultEnv];
}

function detectRegion(domain: string): Region {
  for (const [regionName, region] of Object.entries(regions)) {
    for (const [regionName2, regDomains] of Object.entries(regionDomains)) {
      if (regionName === regionName2 && regDomains.includes(domain)) {
        return region;
      }
    }
  }
  return regions[defaultRegion];
}

export const environment = detectEnv(window.location.hostname);
export const region = detectRegion(window.location.hostname);

export const passportPartnersByRegion: Record<string, string[]> = {
  US: ['comcast'],
  UK: ['comcast', 'sky-group'],
  east: ['comcast'],
  west: ['comcast'],
};

export const passportPartners = [
  {
    name: 'comcast',
    label: 'Comcast',
    main_partner: true,
    id: '1',
    icon: 'https://ptgw-preprod.xcal.tv/rails/active_storage/blobs/proxy/eyJfcmFpbHMiOnsiZGF0YSI6NzYsInB1ciI6ImJsb2JfaWQifX0=--80de2f61e4d60cbfaa41931e2c1c0caef3fe0d5a/comcast.svg',
    auth_url: ({ returnUrl }: { returnUrl: string }) =>
      `https://${environment.passportEndpoint}/xerxes-sp/protected/auth?client_id=${environment.comcastClientId}&partner-id=comcast&response_type=code&continue=${returnUrl}`,
    system_branding_icon:
      'https://ptgw-preprod.xcal.tv/rails/active_storage/blobs/proxy/eyJfcmFpbHMiOnsiZGF0YSI6ODIsInB1ciI6ImJsb2JfaWQifX0=--8a8f94d4b0f09a34fa9172592e00ff9189f3c2de/35f2285728e7a8b78efe3b36327f7cfa.svg',
    system_branding_copyright_text: 'COMCAST',
  },
  {
    name: 'sky-group',
    label: 'Sky Group',
    main_partner: false,
    id: '64',
    icon: 'https://ptgw-preprod.xcal.tv/rails/active_storage/blobs/proxy/eyJfcmFpbHMiOnsiZGF0YSI6NjgsInB1ciI6ImJsb2JfaWQifX0=--674b7510187cfb094a514da19775a221efc6e547/fd737e41ba0b55729761d1b590fa88cf.svg',
    auth_url: ({ returnUrl }: { returnUrl: string }) =>
      `https://${environment.passportEndpoint}/xerxes-sp/protected/auth?client_id=${environment.comcastClientId}&partner-id=sky-group&response_type=code&continue=${returnUrl}`,
    system_branding_icon: null,
    system_branding_copyright_text: null,
  },
];

export const agGridInfo = {
  key: 'Using_this_{AG_Grid}_Enterprise_key_{AG-051167}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Comcast_Corporation}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{18_March_2025}____[v3]_[01]_MTc0MjI1NjAwMDAwMA==eafb77927c5768e9dc0b89e6a2f1cfb7',
};
